



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cutoverplan, Environment, Phase } from '@/types';

@Component({})
export default class PhaseRow extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  selectedEnvironmentPhase!: number;

  @Prop()
  environment!: Environment;

  @Prop()
  phase!: Phase;

  get selectedPhaseStart() {
    const cutoverplanPhase = this.cutoverplan?.phases?.find(
      (phase: Phase) =>
        phase.phase_id === this.phase.id && phase.environment_id === (this.environment.id || null)
    );

    return cutoverplanPhase?.start || '';
  }

  set selectedPhaseStart(value: string) {
    const cutoverplanPhase = this.cutoverplan?.phases?.find(
      (phase: Phase) =>
        phase.phase_id === this.phase.id && phase.environment_id === (this.environment.id || null)
    );

    if (cutoverplanPhase) cutoverplanPhase.start = value;
    else {
      this.cutoverplan.phases.push({
        environment_id: this.environment.id || null,
        id: this.phase.id,
        phase_id: this.phase.id,
        name: this.phase.name,
        start: value
      } as Phase);
    }
  }

  isDateTime(value: string): true | string {
    const validDate = !!value.trim().match(/\d\d\d\d-\d\d-\d\d \d\d:\d\d:\d\d$/);
    return !value || validDate || 'Bitte folgendes Format einhalten: YYYY-MM-DD hh:mm:ss';
  }
}
